import React from "react";
import { styles } from "../styles/theme";
import { formatMoney } from "../utils/helpers";

function LobbyPage({ playerName, players, timeLeft, isSpectator = false, currentRound = 1, isEliminated = false, topBids = [], gameData = null, allPlayers = [] }) {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div style={styles.page}>
      <div style={{
        ...styles.card,
        maxWidth: "700px",
        width: "100%"
      }}>
        <h1 style={{
          ...styles.title,
          marginBottom: "10px"
        }}>
          {isEliminated ? "Eliminado del Juego" : isSpectator ? "Juego en Curso" : "Sala de Espera"}
        </h1>
        
        {isEliminated ? (
          <div style={{
            marginBottom: "30px",
            padding: "20px",
            background: "#ffebee",
            borderRadius: "10px",
            border: "2px solid #f44336"
          }}>
            <p style={{
              margin: "0 0 10px 0",
              color: "#c62828",
              fontSize: "18px",
              fontWeight: "bold",
              textAlign: "center"
            }}>
              ❌ Has sido eliminado
            </p>
            <p style={{
              margin: 0,
              color: "#c62828",
              fontSize: "16px",
              textAlign: "center",
              lineHeight: "1.6"
            }}>
              No conseguiste pan en la ronda anterior.
              <br />Podrás unirte cuando comience una nueva partida.
            </p>
          </div>
        ) : isSpectator ? (
          <div style={{
            marginBottom: "30px",
            padding: "20px",
            background: "#fff3cd",
            borderRadius: "10px",
            border: "2px solid #ffc107"
          }}>
            <p style={{
              margin: "0 0 10px 0",
              color: "#856404",
              fontSize: "18px",
              fontWeight: "bold",
              textAlign: "center"
            }}>
              ⚠️ El juego ya ha comenzado
            </p>
            <p style={{
              margin: 0,
              color: "#856404",
              fontSize: "16px",
              textAlign: "center",
              lineHeight: "1.6"
            }}>
              No puedes unirte hasta que comience una nueva partida.
              <br />Puedes observar el progreso del juego actual.
            </p>
          </div>
        ) : (
          <p style={{
            ...styles.subtitle,
            marginBottom: "30px",
            fontSize: "16px"
          }}>
            ¡Bienvenido {playerName}! El juego comenzará pronto.
          </p>
        )}

        {/* Contador grande */}
        <div style={{
          background: (isSpectator || isEliminated)
            ? "linear-gradient(135deg, #ff6b6b 0%, #c44569 100%)"
            : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          borderRadius: "20px",
          padding: "40px 20px",
          marginBottom: "40px",
          boxShadow: (isSpectator || isEliminated)
            ? "0 10px 30px rgba(255, 107, 107, 0.3)"
            : "0 10px 30px rgba(102, 126, 234, 0.3)"
        }}>
          {(isSpectator || isEliminated) && (
            <div style={{
              fontSize: "20px",
              color: "rgba(255,255,255,0.95)",
              marginBottom: "10px",
              fontWeight: "600"
            }}>
              Ronda {currentRound}
            </div>
          )}
          <div style={{
            fontSize: "18px",
            color: "rgba(255,255,255,0.9)",
            marginBottom: "15px",
            fontWeight: "500"
          }}>
            {(isSpectator || isEliminated) ? "Tiempo restante de la ronda:" : "El juego comienza en:"}
          </div>
          <div style={{
            fontSize: "80px",
            fontWeight: "bold",
            color: "white",
            fontFamily: "'Courier New', monospace",
            textShadow: "0 4px 10px rgba(0,0,0,0.2)"
          }}>
            {formatTime(timeLeft)}
          </div>
        </div>
            {/* Ranking de ofertas para eliminados/espectadores, objetivo para jugadores en espera */}
            {(isSpectator || isEliminated) ? (
              <div style={{
                marginTop: "30px",
                padding: "20px",
                background: "#f8f9fa",
                borderRadius: "10px",
                border: "1px solid #e0e0e0"
              }}>
                <h3 style={{
                  margin: "0 0 15px 0",
                  color: "#333",
                  fontSize: "18px",
                  fontWeight: "bold",
                  textAlign: "center"
                }}>
                  📊 Ranking de Ofertas - Ronda {currentRound}
                </h3>
                {(() => {
                  // Calcular cuántos panes se darán en esta ronda
                  const activePlayers = allPlayers.filter(p => p.active !== false);
                  const numActivePlayers = activePlayers.length;
                  
                  // Nueva lógica de distribución de panes
                  let panesADar;
                  if (numActivePlayers <= 3) {
                    panesADar = 1; // Solo 1 ganador cuando quedan 3 o menos (ronda final)
                  } else if (numActivePlayers <= 5) {
                    panesADar = numActivePlayers - 1; // Eliminar 1 cuando quedan 4-5 jugadores
                  } else if (numActivePlayers > 15) {
                    panesADar = numActivePlayers - 4; // Eliminar 4 cuando hay más de 15
                  } else {
                    panesADar = numActivePlayers - 3; // Eliminar 3 cuando hay de 6 a 15
                  }
                  
                  const isFinalRound = numActivePlayers <= 3;

                  // Crear un mapa de ofertas por jugador
                  const bidsByPlayer = {};
                  topBids.forEach(bid => {
                    bidsByPlayer[bid.playerId] = bid.amount;
                  });

                  // Crear lista de jugadores con sus ofertas
                  const playersList = activePlayers.map(player => ({
                    playerId: player.id,
                    playerName: player.name,
                    amount: bidsByPlayer[player.id] || 0,
                    hasBid: bidsByPlayer[player.id] !== undefined
                  })).sort((a, b) => b.amount - a.amount);

                  return (
                    <>
                      <div style={{
                        fontSize: "14px",
                        color: "#666",
                        marginBottom: "10px",
                        textAlign: "center"
                      }}>
                        {isFinalRound 
                          ? `🏆 RONDA FINAL: Solo 1 pan disponible` 
                          : `🍞 Esta ronda se darán ${panesADar} panes (Top ${panesADar} ofertas)`
                        }
                      </div>
                      <ol style={{ 
                        margin: "0",
                        paddingLeft: "20px",
                        listStyle: "decimal"
                      }}>
                        {playersList.length === 0 && (
                          <li style={{ color: "#888" }}>Esperando jugadores...</li>
                        )}
                        {playersList.map((player, index) => (
                          <li key={player.playerId} style={{ 
                            marginBottom: "8px",
                            color: player.hasBid ? "#333" : "#888",
                            fontSize: "14px"
                          }}>
                            {index < panesADar && "🍞 "}
                            <strong>{player.playerName}:</strong> {player.hasBid ? formatMoney(player.amount) : "Sin oferta"}
                          </li>
                        ))}
                      </ol>
                    </>
                  );
                })()}
              </div>
            ) : (
              <div style={{
                marginTop: "30px",
                padding: "20px",
                background: "#e3f2fd",
                borderRadius: "10px",
                border: "1px solid #90caf9"
              }}>
                <p style={{
                  margin: 0,
                  color: "#1565c0",
                  fontSize: "14px",
                  textAlign: "center",
                  lineHeight: "1.6"
                }}>
                  🎯 <strong>Objetivo del Juego:</strong> Sobrevive comprando pan en cada ronda.
                  <br />
                  <strong>Cómo jugar:</strong> Gana dinero con mini-juegos, puja por el pan y vota sobre la ayuda social.
                </p>
              </div>
            )}

        {/* Lista de jugadores */}
        <div>
          <h2 style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "20px",
            textAlign: "left"
          }}>
            {(isSpectator || isEliminated) ? `Jugadores activos (${players.length})` : `Jugadores en el lobby (${players.length})`}
          </h2>
          
          <div style={{
            background: "#f8f9fa",
            borderRadius: "15px",
            padding: "20px",
            maxHeight: "300px",
            overflowY: "auto"
          }}>
            {players.length === 0 ? (
              <p style={{
                color: "#666",
                textAlign: "center",
                fontSize: "16px"
              }}>
                Esperando jugadores...
              </p>
            ) : (
              <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                gap: "12px"
              }}>
                {players.map((player, index) => (
                  <div
                    key={player.id}
                    style={{
                      background: "white",
                      padding: "15px",
                      borderRadius: "10px",
                      border: !isSpectator && player.name === playerName ? "2px solid #667eea" : "1px solid #e0e0e0",
                      boxShadow: !isSpectator && player.name === playerName 
                        ? "0 4px 12px rgba(102, 126, 234, 0.2)"
                        : "0 2px 4px rgba(0,0,0,0.05)",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px"
                    }}
                  >
                    <div style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      background: !isSpectator && player.name === playerName 
                        ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                        : "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "18px",
                      flexShrink: 0
                    }}>
                      {player.name.charAt(0).toUpperCase()}
                    </div>
                    <div style={{
                      flex: 1,
                      overflow: "hidden"
                    }}>
                      <div style={{
                        fontWeight: "600",
                        color: "#333",
                        fontSize: "16px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                      }}>
                        {player.name}
                        {!isSpectator && player.name === playerName && (
                          <span style={{
                            fontSize: "12px",
                            color: "#667eea",
                            marginLeft: "8px",
                            fontWeight: "500"
                          }}>
                            (Tú)
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  );
}

export default LobbyPage;
